'use strict';
import { isDesktopLarge } from './responsiveViewport';

function getElementTopOffset () {
  var headerOffset = 0;
  var flyingMenuOffset = 0;
  if (!$('body').hasClass('no-header')) {
    headerOffset = $('header.navbar-fixed-top').height() || 60;
  }
  if (!isDesktopLarge()) {
    flyingMenuOffset = $('#flying').height() || 70;
  }
  return Math.abs(headerOffset + flyingMenuOffset);
}

function scrollTo (id, speed, easing, callback) {
  var $element;
  var destination = 0;
  var $body = $('html, body');
  speed = speed || 0;

  if (typeof id === 'string') {
    $element = $(id);
  } else {
    $element = id;
  }

  if ($element.length) {
    var layoutOffset = getElementTopOffset();
    destination = $element.offset().top - layoutOffset;
    return $body.stop().animate({
      scrollTop: destination
    }, speed, easing, callback);
  }
}

module.exports = scrollTo;
